module.exports = __webpack_public_path__ + "img/mac-icon1.e9c81bf.png";